<template>
	<div class="table-form-blocks">

		<div class="has-blocks" v-if="blocks && blocks.length > 0">
			<div class="the-table">
				<div class="headers">
					<div class="row">
						<span>Reference</span>
						<span>Time points</span>
						<span>Technical File</span>
						<span>Priority</span>
						<span>Active</span>
						<span>Options</span>
					</div>
				</div>

				<div class="table">
					<div 
						class="row"
						v-for="(block, index) in blocks"
						:key="index"
						>
						<span>
							{{ block.name }}
						</span>
						<span>
							{{ timePointOutput(block.timepoint) }}
						</span>
						<span class="smaller">
							{{ techFilesOutput(block.technical_files) }}
						</span>
						<span>
							{{ block.priority }}
						</span>
						<span>
							<div 
								class="active-dot" 
								:class="block.active ? 'active' : 'inactive'"
								/>
						</span>
						<span>
							<a :href="`/admin/pms-forms/${formID}/blocks/${block.id}/edit`">
								<i 
									class="fal fa-pencil"
									@click="editFormBlock(block.id)"
									/>
							</a>
							<i 
								class="fal fa-trash-alt"
								v-if="$page.props.user.user_type == 'admin'"
								@click="openDeleteModal(block.id)"
								/>
						</span>
					</div>
				</div>
			</div>

		</div>

		<div class="empty-results" v-else>
			<Placeholder 
				message="No form blocks found!"
				>

				<a :href="`/admin/pms-forms/${formID}/blocks/new`">
					<Button 
						label="Add new form block"
						color="green"
						size="regular"
						icon="plus"
						/>
				</a>

			</Placeholder>
		</div>

		<Modal 
			v-if="deleteModalOpen && formBlockIdToDelete"
			title="Delete Form Block"
			@close="closeDeleteModal"
			>

			<span>
				Are you sure you wish to delete this form block? This action cannot be undone.
			</span>

			<div class="buttons">
				<Button 
					label="Yes, delete"
					color="red"
					size="regular"
					icon="trash-alt"
					@click="deleteFormBlock"
					/>

				<Button
					label="Cancel"
					color="white"
					size="regular"
					icon="times"
					@click="closeDeleteModal"
					/>
			</div>
		</Modal>

	</div>
</template>

<script>

import Placeholder from "@/Components/Placeholder"
import Button from "@/Components/Button"
import Modal from "@/Components/Modal"

export default {
	components: {
		Placeholder,
		Button,
		Modal
	},
	props: {
		blocks: [Array, Object],
		formID: Number,
	},
	data: () => {
		return {
			deleteModalOpen: false,
			formBlockIdToDelete: null	
		}
	},
	mounted(){

		// console.log('blocks', this.blocks)
	},
	methods: {
		openDeleteModal(id){
			this.deleteModalOpen = true
			this.formBlockIdToDelete = id
		},
		closeDeleteModal(){
			this.deleteModalOpen = false
			this.formBlockIdToDelete = null
		},
		deleteFormBlock(){

			this.$inertia.post(`/admin/pms-forms/${this.formID}/blocks/${this.formBlockIdToDelete}/delete`, {},
			{
				onFinish: () => {
					this.closeDeleteModal()
					this.$emit('deletedFormBlock', this.formBlockIdToDelete)
				}
			})
			
		},
		addNewFormBlock(){
			this.$emit('addNewFormBlock')
		},
		editFormBlock(id){
			this.$emit('editFormBlock', id)
		},
		timePointOutput(timepoint){

			if(timepoint){
				switch(timepoint.mode){
					case 'always':
						return 'Always'
					case 'time-intervals':
						let weeks = timepoint.points.map(point => point.weeks).join(', ')
						return 'Weeks: ' + weeks
					default:
						return 'N/A'
				}
			}else{
				return 'N/A'
			}
		},
		techFilesOutput(techFiles){
			if(techFiles && techFiles.length > 0){
				return techFiles.map(file => file.name).join(', ')
			}else{
				return '-'
			}
		}
	},
	computed: {
		
	},
}
</script>

<style lang="sass" scoped>

.table-form-blocks
	width: 100%
	display: flex
	flex-direction: column
	margin-bottom: 30px

	.has-blocks
		display: flex
		flex-direction: column
		gap: 20px
		margin-bottom: 20px

	.the-table
		.headers
			font-size: 18px
			font-weight: 700
			font-family: 'Roboto Condensed', sans-serif
			color: #252525
			line-height: 1.1
			margin-bottom: 10px

			.row
				padding: 0 20px

		.row
			display: grid
			grid-template-columns: 1fr 0.5fr 0.3fr 0.3fr 0.3fr 140px

			span
				display: flex
				align-items: center

				&:last-child
					justify-content: flex-end

			.active-dot
				width: 15px
				height: 15px
				border-radius: 50%
				background-color: #d00
				transition: all 300ms

				&.active
					background-color: #0d0

		@media (max-width: 900px)
			overflow-x: auto
			
			.row
				display: flex

				span
					min-width: 190px

		.table
			width: 100%
			background-color: #fff
			border-radius: 8px
			box-shadow: 0 1px 3px rgba(#000, 0.12)
			padding: 0 20px

			.row
				font-size: 16px
				font-weight: 400
				font-family: 'Roboto', sans-serif
				color: #252525
				line-height: 1.1
				height: 60px
				border-bottom: 1px solid #d0d0d0
				align-items: center

				&.deleting
					color: darken(#f00, 10%)

				&:last-child
					border-bottom: none

				.fal
					font-size: 22px
					color: #252525
					margin-left: 20px
					transition: all 300ms
					cursor: pointer

					&:hover
						opacity: 0.7

	.buttons
		margin-top: 20px
		display: flex
		gap: 10px

</style>
